var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import Box from "../components/box/Box";
import Flex from "../components/box/Flex";
import Text from "../components/text/Text";
export const getScreenReaderOnlyStyles = () => ({
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    border: 0,
    opacity: 0,
});
export const StyledHiddenScreenReaderOnly = styled(Box).attrs({ tabIndex: -1 }).withConfig({ displayName: "StyledHiddenScreenReaderOnly_APC-7281-productShell", componentId: "sc-82yon7" })(getScreenReaderOnlyStyles());
export const StyledContents = styled.div.withConfig({ displayName: "StyledContents_APC-7281-productShell", componentId: "sc-b1rz9b" })({
    display: "contents",
});
export const StyledWordBreak = styled.div.withConfig({ displayName: "StyledWordBreak_APC-7281-productShell", componentId: "sc-wff8t" })({
    overflow: "hidden",
    wordBreak: "break-word",
});
export const lineClamp = (lines) => ({
    display: "-webkit-box",
    overflow: "hidden",
    wordBreak: "break-word",
    WebkitLineClamp: lines,
    WebkitBoxOrient: "vertical",
});
/**
 * limits the text to a given number of lines, with ellipsis at the end.
 * avoid using this if the text is right-aligned, as the ellipsis might be hidden.
 */
export const StyledLineClamp = styled.div.withConfig({ displayName: "StyledLineClamp_APC-7281-productShell", componentId: "sc-riqny3" })(({ lines }) => lineClamp(lines));
/** this is useful to align the content to the center of a specific variant of Text */
export const StyledAlignToTextCenter = styled((_a) => {
    var { variant, children } = _a, flexProps = __rest(_a, ["variant", "children"]);
    return (React.createElement(Flex, Object.assign({}, flexProps),
        React.createElement(Text, { variant: variant }, "\u200B"),
        children));
}).withConfig({ displayName: "StyledAlignToTextCenter_APC-7281-productShell", componentId: "sc-z0sumu" })({
    alignItems: "center",
});
//# sourceMappingURL=StyleUtils.js.map